import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'
import { offlineDB } from '../services/offlineDB'
import { Save, Eye, EyeOff, Building2, Mail, FileText, User, Lock, Settings } from 'lucide-react'

export default function Configuracion() {
  const [loading, setLoading] = useState(false)
  const [mostrarPassword, setMostrarPassword] = useState(false)
  const [config, setConfig] = useState({
    // Datos empresa
    nombre_empresa: 'Panadería Hermanos Alonso',
    cif: '',
    direccion: '',
    cp: '',
    poblacion: '',
    provincia: '',
    telefono: '',
    email: '',
    
    // Gestoría
    email_gestoria: '',
    nombre_gestoria: '',
        
    // Impresora
    nombre_impresora_bluetooth: '',
    ancho_papel: 58,

    // Certificado VeriFactu
    cert_p12_filename: '',
    cert_p12_password: '',
    cert_fecha_caducidad: '',
    verifactu_modo: 'test'
  })

  const [certificadoFile, setCertificadoFile] = useState(null)
  const [usuarios, setUsuarios] = useState([])
  const [cambioPassword, setCambioPassword] = useState({
    usuario_id: '',
    password_actual: '',
    password_nueva: '',
    password_confirmacion: ''
  })

  useEffect(() => {
    cargarConfiguracion()
    cargarUsuarios()
  }, [])

  // ========== FUNCIÓN ACTUALIZAR (FALTABA) ==========
  function actualizar(campo, valor) {
    console.log(`📝 Actualizando ${campo}:`, valor)
    setConfig(prev => ({
      ...prev,
      [campo]: valor
    }))
  }

  async function cargarConfiguracion() {
    try {
      const { data, error } = await supabase
        .from('configuracion')
        .select('*')
        .limit(1)
        .maybeSingle()
      
      if (data) {
        console.log('✅ Configuración cargada:', data)
        setConfig(prev => ({ ...prev, ...data }))
      } else {
        console.log('ℹ️ No hay configuración guardada')
      }
    } catch (error) {
      console.error('Error cargando configuración:', error)
    }
  }

  async function cargarUsuarios() {
    try {
      console.log('📋 Cargando usuarios...')
      
      // Intentar cargar desde Supabase
      if (navigator.onLine) {
        const { data, error } = await supabase
          .from('users')
          .select('id, username, rol')
          .order('username')
        
        if (!error && data) {
          console.log('✅ Usuarios cargados desde Supabase:', data)
          setUsuarios(data)
          return
        }
      }
      
      // Si falla o no hay conexión, usar caché
      console.log('📱 Cargando usuarios desde caché...')
      const cached = await offlineDB.getCachedUsers()
      console.log('✅ Usuarios cargados desde caché:', cached)
      setUsuarios(cached || [])
    } catch (error) {
      console.error('❌ Error cargando usuarios:', error)
    }
  }

  async function guardarConfiguracion() {
    setLoading(true)
    
    try {
      console.log('💾 Guardando configuración...')
      console.log('Datos a guardar:', config)
      
      // PASO 1: Subir certificado si hay uno nuevo
      if (certificadoFile) {
        console.log('📤 Subiendo certificado:', certificadoFile.name)
        
        const fileName = `cert-${Date.now()}.p12`
        const { data: uploadData, error: uploadError } = await supabase.storage
          .from('certificados')
          .upload(fileName, certificadoFile, { 
            cacheControl: '3600',
            upsert: true 
          })
        
        if (uploadError) {
          console.error('❌ Error subiendo certificado:', uploadError)
          alert('Error subiendo certificado: ' + uploadError.message)
          setLoading(false)
          return
        }
        
        console.log('✅ Certificado subido:', fileName)
        config.cert_p12_filename = fileName
      }
      
      // PASO 2: Verificar si existe configuración
      const { data: existente, error: errorCheck } = await supabase
        .from('configuracion')
        .select('id')
        .limit(1)
        .maybeSingle()
      
      console.log('Configuración existente:', existente ? `ID ${existente.id}` : 'NO')
      
      let resultado
      
      if (existente) {
        // ACTUALIZAR
        console.log('📝 Actualizando configuración existente...')
        const { data, error } = await supabase
          .from('configuracion')
          .update(config)
          .eq('id', existente.id)
          .select()
        
        resultado = { data, error }
      } else {
        // INSERTAR
        console.log('✨ Creando nueva configuración...')
        const { data, error } = await supabase
          .from('configuracion')
          .insert([config])
          .select()
        
        resultado = { data, error }
      }
      
      if (resultado.error) {
        console.error('❌ Error guardando:', resultado.error)
        throw resultado.error
      }
      
      console.log('✅ Configuración guardada:', resultado.data)
      alert('✅ Configuración guardada correctamente')
      
      // Recargar configuración
      await cargarConfiguracion()
      
    } catch (error) {
      console.error('❌ Error completo:', error)
      alert('Error al guardar: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  async function cambiarPassword() {
    if (!cambioPassword.usuario_id) {
      alert('Selecciona un usuario')
      return
    }
    
    if (cambioPassword.password_nueva !== cambioPassword.password_confirmacion) {
      alert('Las contraseñas nuevas no coinciden')
      return
    }
    
    if (cambioPassword.password_nueva.length < 4) {
      alert('La contraseña debe tener al menos 4 caracteres')
      return
    }

    setLoading(true)
    try {
      const usuarioId = Number(cambioPassword.usuario_id)
      
      if (navigator.onLine) {
        console.log('🔐 Cambiando contraseña online...')
        
        // Verificar contraseña actual
        const { data: usuario } = await supabase
          .from('users')
          .select('password')
          .eq('id', usuarioId)
          .single()
        
        if (usuario.password !== cambioPassword.password_actual) {
          alert('Contraseña actual incorrecta')
          return
        }
        
        // Actualizar contraseña en Supabase
        const { error } = await supabase
          .from('users')
          .update({ password: cambioPassword.password_nueva })
          .eq('id', usuarioId)
        
        if (error) throw error
        
        // Actualizar caché local
        const usuariosActualizados = usuarios.map(u => {
          if (u.id === usuarioId) {
            return { ...u, password: cambioPassword.password_nueva }
          }
          return u
        })
        await offlineDB.cacheUsers(usuariosActualizados)
        
        alert('✅ Contraseña cambiada correctamente. Afectará a todos los dispositivos.')
      } else {
        alert('❌ Necesitas conexión a internet para cambiar contraseñas')
        return
      }
      
      setCambioPassword({
        usuario_id: '',
        password_actual: '',
        password_nueva: '',
        password_confirmacion: ''
      })
      
      // Recargar usuarios
      await cargarUsuarios()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al cambiar contraseña: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>⚙️ Configuración</h1>
      </div>

      <div style={{ display: 'grid', gap: '1.5rem', maxWidth: '1200px' }}>
        
        {/* DATOS EMPRESA */}
        <div className="card">
          <div className="card-header">
            <Building2 size={20} />
            <h2>Datos de la Empresa</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div style={{ gridColumn: '1 / -1' }}>
              <label className="form-label">Nombre de la empresa</label>
              <input
                type="text"
                value={config.nombre_empresa}
                onChange={(e) => actualizar('nombre_empresa', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div>
              <label className="form-label">CIF</label>
              <input
                type="text"
                value={config.cif}
                onChange={(e) => actualizar('cif', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div>
              <label className="form-label">Teléfono</label>
              <input
                type="text"
                value={config.telefono}
                onChange={(e) => actualizar('telefono', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div style={{ gridColumn: '1 / -1' }}>
              <label className="form-label">Dirección</label>
              <input
                type="text"
                value={config.direccion}
                onChange={(e) => actualizar('direccion', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div>
              <label className="form-label">Código Postal</label>
              <input
                type="text"
                value={config.cp}
                onChange={(e) => actualizar('cp', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div>
              <label className="form-label">Población</label>
              <input
                type="text"
                value={config.poblacion}
                onChange={(e) => actualizar('poblacion', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div style={{ gridColumn: '1 / -1' }}>
              <label className="form-label">Provincia</label>
              <input
                type="text"
                value={config.provincia}
                onChange={(e) => actualizar('provincia', e.target.value)}
                className="form-input"
              />
            </div>
            
            <div style={{ gridColumn: '1 / -1' }}>
              <label className="form-label">Email</label>
              <input
                type="email"
                value={config.email}
                onChange={(e) => actualizar('email', e.target.value)}
                className="form-input"
              />
            </div>
          </div>
        </div>

        {/* GESTORÍA */}
        <div className="card">
          <div className="card-header">
            <FileText size={20} />
            <h2>Gestoría</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <label className="form-label">Nombre de la gestoría</label>
              <input
                type="text"
                value={config.nombre_gestoria}
                onChange={(e) => actualizar('nombre_gestoria', e.target.value)}
                className="form-input"
                placeholder="Ej: Gestoría López y Asociados"
              />
            </div>
            
            <div>
              <label className="form-label">Email de la gestoría</label>
              <input
                type="email"
                value={config.email_gestoria}
                onChange={(e) => actualizar('email_gestoria', e.target.value)}
                className="form-input"
                placeholder="Donde enviar las facturas"
              />
            </div>
          </div>
        </div>

        {/* IMPRESORA */}
        <div className="card">
          <div className="card-header">
            <User size={20} />
            <h2>Configuración de Impresora</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <label className="form-label">Nombre de impresora Bluetooth</label>
              <input
                type="text"
                value={config.nombre_impresora_bluetooth}
                onChange={(e) => actualizar('nombre_impresora_bluetooth', e.target.value)}
                className="form-input"
                placeholder="Ej: RPP02N"
              />
            </div>
            
            <div>
              <label className="form-label">Ancho del papel (mm)</label>
              <select
                value={config.ancho_papel}
                onChange={(e) => actualizar('ancho_papel', Number(e.target.value))}
                className="form-input"
              >
                <option value="58">58mm</option>
                <option value="80">80mm</option>
              </select>
            </div>
          </div>
        </div>

        {/* CAMBIAR CONTRASEÑA */}
        <div className="card">
          <div className="card-header">
            <Lock size={20} />
            <h2>Cambiar Contraseña</h2>
          </div>
          <div style={{ display: 'grid', gap: '1rem', maxWidth: '500px' }}>
            <div>
              <label className="form-label">Usuario</label>
              <select
                value={cambioPassword.usuario_id}
                onChange={(e) => setCambioPassword(prev => ({ ...prev, usuario_id: e.target.value }))}
                className="form-input"
              >
                <option value="">Seleccionar usuario...</option>
                {usuarios.length === 0 ? (
                  <option disabled>Cargando usuarios...</option>
                ) : (
                  usuarios.map(u => (
                    <option key={u.id} value={u.id}>{u.username} ({u.rol})</option>
                  ))
                )}
              </select>
            </div>
            
            <div>
              <label className="form-label">Contraseña actual</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={mostrarPassword ? 'text' : 'password'}
                  value={cambioPassword.password_actual}
                  onChange={(e) => setCambioPassword(prev => ({ ...prev, password_actual: e.target.value }))}
                  className="form-input"
                />
                <button
                  onClick={() => setMostrarPassword(!mostrarPassword)}
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'var(--muted)'
                  }}
                >
                  {mostrarPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            
            <div>
              <label className="form-label">Contraseña nueva</label>
              <input
                type={mostrarPassword ? 'text' : 'password'}
                value={cambioPassword.password_nueva}
                onChange={(e) => setCambioPassword(prev => ({ ...prev, password_nueva: e.target.value }))}
                className="form-input"
              />
            </div>
            
            <div>
              <label className="form-label">Confirmar contraseña nueva</label>
              <input
                type={mostrarPassword ? 'text' : 'password'}
                value={cambioPassword.password_confirmacion}
                onChange={(e) => setCambioPassword(prev => ({ ...prev, password_confirmacion: e.target.value }))}
                className="form-input"
              />
            </div>
            
            <button
              onClick={cambiarPassword}
              disabled={loading}
              className="btn-primary"
              style={{ width: 'fit-content' }}
            >
              <Lock size={18} />
              Cambiar contraseña
            </button>
          </div>
        </div>

        {/* CERTIFICADO VERIFACTU */}
        <div className="card">
          <div className="card-header">
            <Lock size={20} />
            <h2>Certificado VeriFactu</h2>
          </div>
          
          <div style={{ display: 'grid', gap: '1rem' }}>
            <div>
              <label className="form-label">Modo VeriFactu</label>
              <select
                value={config.verifactu_modo}
                onChange={(e) => actualizar('verifactu_modo', e.target.value)}
                className="form-input"
              >
                <option value="test">Pruebas (Test)</option>
                <option value="produccion">Producción</option>
              </select>
            </div>
            
            <div>
              <label className="form-label">Certificado .p12 / .pfx</label>
              <input
                type="file"
                accept=".p12,.pfx"
                onChange={(e) => {
                  const file = e.target.files[0]
                  if (file) {
                    setCertificadoFile(file)
                    console.log('📄 Certificado seleccionado:', file.name)
                  }
                }}
                className="form-input"
              />
              {config.cert_p12_filename && (
                <div style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: 'var(--accent)' }}>
                  ✓ Certificado actual: {config.cert_p12_filename}
                </div>
              )}
            </div>
            
            <div>
              <label className="form-label">Contraseña del certificado</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={mostrarPassword ? 'text' : 'password'}
                  value={config.cert_p12_password || ''}
                  onChange={(e) => actualizar('cert_p12_password', e.target.value)}
                  className="form-input"
                  placeholder="Contraseña del archivo .p12"
                />
                <button
                  type="button"
                  onClick={() => setMostrarPassword(!mostrarPassword)}
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'var(--muted)'
                  }}
                >
                  {mostrarPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            
            <div>
              <label className="form-label">Fecha de caducidad</label>
              <input
                type="date"
                value={config.cert_fecha_caducidad || ''}
                onChange={(e) => actualizar('cert_fecha_caducidad', e.target.value)}
                className="form-input"
              />
              {config.cert_fecha_caducidad && (
                <div style={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>
                  {(() => {
                    const diasRestantes = Math.floor((new Date(config.cert_fecha_caducidad) - new Date()) / (1000 * 60 * 60 * 24))
                    return diasRestantes < 30 ? (
                      <span style={{ color: 'var(--warn)' }}>
                        ⚠️ Caduca en {diasRestantes} días
                      </span>
                    ) : (
                      <span style={{ color: 'var(--accent)' }}>
                        ✓ Válido ({diasRestantes} días restantes)
                      </span>
                    )
                  })()}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* BOTÓN GUARDAR */}
        <div style={{ position: 'sticky', bottom: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={guardarConfiguracion}
            disabled={loading}
            className="btn-primary"
            style={{ fontSize: '1rem', padding: '0.875rem 2rem' }}
          >
            <Save size={20} />
            {loading ? 'Guardando...' : 'Guardar Configuración'}
          </button>
        </div>
      </div>
    </div>
  )
}